<template>
  <v-card class="my-5 py-5">
    <v-data-table
      class="px-3 datatable-others"
      :headers="wrappedTableHeaders"
      :items="wrappedOthersAttachments"
      :items-per-page="5"
      item-key="id"
      :show-select="false"
      no-data-text="Sin elementos actualmente"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>
            <small class="font-weight-bold">
              Otros
            </small>
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-btn
            v-if="showActions"
            color="blue darken-3"
            :disabled="currentCubage && currentCubage.isClosed"
            @click="openModalAddOthersAttachments"
            :dark="false"
            size="small"
          >
            <span class="text-white">
              Agregar nuevo
            </span>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.desc="{ item }">
        <p class="text-left mt-2">
          {{ item.desc }}
        </p>
      </template>
      <template v-slot:item.created_at="{ item }">
        <p class="mt-2">
          {{ new Date(item.created_at).toLocaleDateString() }}
        </p>
      </template>
      <template v-slot:item.unit_cost="{ item }">
        <v-text-field
          type="number"
          :min="0"
          @focusout="updateOtherAttachment($event, item, 'unit_cost')"
          class="pt-0 mt-0"
          hide-details
          :value="item.unit_cost"
        ></v-text-field>
      </template>
      <template v-slot:item.quantity="{ item }">
        <v-text-field
          type="number"
          :min="0"
          @focusout="updateOtherAttachment($event, item, 'quantity')"
          class="pt-0 mt-0"
          hide-details
          :value="item.quantity"
        ></v-text-field>
      </template>
      <template v-slot:item.format="{ item }">
        <p class="text-center mt-2 mr-3">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                target="_blank"
                :href="item.download_url"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small :color="formatFilesIcons[item.format].color">
                  {{ formatFilesIcons[item.format].file }}
                </v-icon>
              </v-btn>
            </template>
            <span>Descargar archivo</span>
          </v-tooltip>
        </p>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex align-items-center justify-content-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :color="item.comments.length ? 'primary' : 'secondary'"
                @click="openModalShowCommentsModel(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>
                  mdi-alert-circle
                </v-icon>
              </v-btn>
            </template>
            <span>Información</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                color="primary"
                v-bind="attrs"
                v-on="on"
                target="_blank"
                :href="item.download_url"
              >
                <v-icon small>
                  mdi-download
                </v-icon>
              </v-btn>
            </template>
            <span>Descargar archivo</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :disabled="currentCubage && currentCubage.isClosed"
                icon
                color="error"
                @click="deleteItem(item)"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </div>
      </template>
      <template v-slot:item.total_cost="{ item }">
        <span>{{
          `$ ${new Intl.NumberFormat("de-DE").format(
            parseInt(item.total_cost)
          )}`
        }}</span>
      </template>
      <template v-slot:footer.prepend>
        <span class="ml-auto mr-5 text-datatable-board font-weight-bold">
          Total:
          {{
            `$ ${new Intl.NumberFormat("de-DE").format(
              parseInt(getTotalMaterials)
            )}`
          }}
        </span>
      </template>
    </v-data-table>
    <add-others-attachments
      :modalAction="dialogAddOtherAttachments"
      :closeModalAddOthersAttachments="closeModalAddOthersAttachments"
      @attachmentUploaded="
        getCubageOthersAttachments({
          document_id: currentCubage.id,
        })
      "
    ></add-others-attachments>
    <comments-from-model
      :dialogShowCommentsModel="dialogShowCommentsModel"
      :closeModalShowCommentsModel="closeModalShowCommentsModel"
      :modelId="currentAttachment ? currentAttachment.id : null"
      :comments="comments"
      @commentAdded="
        getCubageOthersAttachments({
          document_id: currentCubage.id,
        })
      "
      modelType="document_extras"
    ></comments-from-model>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AddOthersAttachments from "./components/AddAttachments.vue";
import {
  preventCloseIfNotKeyEventEsc,
  getExtensionFileFromUrl,
} from "@/helpers/common";
import { authUsuarioComputed } from "@/state/helpers";
import CommentsFromModel from "../components/CommentsFromModel.vue";
export default {
  props: {
    showActions: {
      type: Boolean,
      default: true,
    },
  },
  components: { AddOthersAttachments, CommentsFromModel },
  data() {
    return {
      debounce: null,
      debounceTime: 200,
      formatFilesIcons: {
        xls: { file: "mdi-file-excel-outline", color: "green" },
        pptx: { file: "mdi-file-powerpoint-outline", color: "orange" },
        doc: { file: "mdi-file-word-outline", color: "blue" },
        pdf: { file: "mdi-file-pdf-box", color: "red" },
        png: { file: "mdi-image-outline", color: "blue" },
        jpg: { file: "mdi-image-outline", color: "blue" },
      },
      dialogAddOtherAttachments: false,
      dialogShowCommentsModel: false,
      tableHeaders: [
        {
          text: "Formato",
          align: "center",
          sortable: false,
          value: "format",
          width: "10%",
        },
        {
          text: "Nombre",
          sortable: false,
          value: "desc",
          width: "30%",
        },
        {
          text: "Cantidad",
          sortable: false,
          align: "center",
          value: "quantity",
          width: "15%",
        },
        {
          text: "Costo unitario",
          sortable: false,
          value: "unit_cost",
          align: "center",
          width: "15%",
        },
        {
          text: "Total",
          sortable: false,
          value: "total_cost",
          align: "center",
          width: "10%",
        },
        {
          text: "Fecha",
          align: "center",
          sortable: false,
          value: "created_at",
          width: "10%",
        },
      ],
      currentAttachment: null,
      comments: [],
    };
  },
  methods: {
    ...mapActions({
      getCubageOthersAttachments: "cubage/getCubageOthersAttachments",
      deleteAttachment: "cubage/deleteAttachment",
      sendUpdateOtherAttachment: "cubage/updateOtherAttachment",
    }),
    openModalAddOthersAttachments() {
      this.dialogAddOtherAttachments = true;
    },
    closeModalAddOthersAttachments($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.dialogAddOtherAttachments = false;
      }
    },
    openModalShowCommentsModel(item) {
      this.currentAttachment = item;
      this.comments = item.comments;
      this.dialogShowCommentsModel = true;
    },
    closeModalShowCommentsModel($event) {
      let validationEvent = preventCloseIfNotKeyEventEsc($event);
      if (validationEvent) {
        this.dialogShowCommentsModel = false;
      }
    },
    updateOtherAttachment(event, item, field) {
      let value = event.target ? event.target.value : event;
      if (value) {
        clearTimeout(this.debounce);
        let self = this;
        this.debounce = setTimeout(async function() {
          let payload = {
            extra_id: item.id,
            quantity: field === "quantity" ? value : item.quantity,
            unit_cost: field === "unit_cost" ? value : item.unit_cost,
            user: self.user.email,
          };
          await self.sendUpdateOtherAttachment(payload);
        }, this.debounceTime);
      }
    },
    deleteItem({ id, desc }) {
      let self = this;
      this.$swal
        .fire({
          icon: "error",
          title: `Deseas eliminar este adjunto: ${desc} ?`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: "Eliminar",
          cancelButtonText: `Cancelar`,
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const resp = await this.deleteAttachment({
              id: id,
              user: self.user.email,
              type: "extras",
            });
            if (resp.status === 200) {
              this.$swal({
                icon: "success",
                title: "Excelente",
                text: "Material eliminado correctamente",
                position: "top-end",
                showConfirmButton: false,
                toast: true,
                timer: 3000,
                timerProgressBar: true,
              });
              self.getCubageOthersAttachments({
                document_id: self.currentCubage.id,
              });
            }
          }
        });
    },
  },
  computed: {
    ...authUsuarioComputed,
    ...mapGetters({
      currentCubage: "cubage/currentCubage",
      cubageOthersAttachments: "cubage/cubageOthersAttachments",
    }),
    wrappedOthersAttachments() {
      return this.cubageOthersAttachments
        .filter((attachment) => attachment.aws_key !== "ELIMINADO")
        .map((attachment) => {
          return {
            ...attachment,
            format: getExtensionFileFromUrl(attachment.aws_key),
            comments: [],
          };
        });
    },
    getTotalMaterials() {
      return this.wrappedOthersAttachments.reduce(
        (total, item) => (total += item.total_cost),
        0
      );
    },
    wrappedTableHeaders() {
      if (this.showActions) {
        return [
          ...this.tableHeaders,
          {
            text: "Acciones",
            align: "center",
            value: "actions",
            sortable: false,
            width: "10%",
          },
        ];
      }
      return this.tableHeaders;
    },
  },
};
</script>

<style>
.datatable-others .v-data-footer__select {
  margin-left: 10px;
}

.datatable-others .v-data-footer {
  display: flex;
  flex-direction: row-reverse;
}

.text-datatable-others {
  font-size: 12.5px;
}
</style>
